import { render, staticRenderFns } from "./SelectLevelInput.vue?vue&type=template&id=2ab22a47&scoped=true"
import script from "./SelectLevelInput.vue?vue&type=script&lang=ts"
export * from "./SelectLevelInput.vue?vue&type=script&lang=ts"
import style0 from "./SelectLevelInput.vue?vue&type=style&index=0&id=2ab22a47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab22a47",
  null
  
)

export default component.exports